export enum FilterAll {
  ALL = "All",
}

export enum GeneType {
  Gene = "gene",
  Alias = "alias",
  GeneAlias = "genealias",
  Fusion = "fusion",
}

export interface ISort<T> {
  label: string;
  field: Extract<keyof T, string>;
  order: SortOrder;
}

export enum SortOrder {
  ASC = "asc",
  DESC = "desc",
}
